module.exports = __webpack_public_path__ + "static/media/digitalPolicy_orange.c95b170f.svg";